import { rejectAllButtonSx } from '../ai-accept-captable-modal/AcceptAICapTableModal.styles';
import AICapTableBulkActionModal from '../ai-accept-captable-modal/AICapTableBulkActionModal';

interface RejectAICapTableModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
  isSubmitting?: boolean;
}

const RejectAICapTableModal = ({
  open,
  onClose,
  onConfirm,
  isSubmitting = false,
}: RejectAICapTableModalProps) => (
  <AICapTableBulkActionModal
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    isSubmitting={isSubmitting}
    title="Reject AI Generated Cap Table"
    contentId="reject-ai-captable-modal-content"
    bodyText="This will reject all AI-generated cap table suggestions."
    helperText="All pending generated columns and field suggestions will be cleared. This action cannot be undone in bulk."
    confirmText="Reject All"
    submittingText="Rejecting…"
    confirmButtonSx={rejectAllButtonSx}
    cancelTestId="reject-ai-captable-modal-cancel"
    confirmTestId="reject-ai-captable-modal-confirm"
  />
);

export default RejectAICapTableModal;
